//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import addOnProductCms from '~/mixins/addOnProductCms';

export default {
    mixins: [addOnProductCms],
    props: {
        open: {
            type: Boolean,
            required: true,
        },
        product: {
            required: true,
        },
    },
    data() {
        return {
            addOnProduct: this.product.linked_insurance_product,
            btnStyle: 'text-xs px-3 py-[6px] text-white font-bold rounded-full',
        };
    },
    computed: {
        insurancePrice() {
            return this.$root.$options.filters.currencyValue(this.addOnProduct?.price);
        },
    },
    methods: {
        hide() {
            this.$emit('close');
            // If side cart is not open, open it
            if (!this.$store.state.cart.open) {
                this.$store.dispatch('cart/openCart', true);
            }
        },
        async activateInsurance() {
            const payload = {
                sku: this.product.linked_insurance_product.sku, //hupsisturva product sku
                insured_product_sku: this.product.sku, //parent product sku
                quantity: 1,
            };

            const { cart, user_errors } = await this.$store.dispatch('cart/activateInsurance', {
                items: [payload],
            });

            if (!user_errors.length) {
                this.$emit('close');
                // If side cart is not open, open it
                if (!this.$store.state.cart.open) {
                    this.$store.dispatch('cart/openCart', true);
                }
            }
        },
    },
};
